import { HttpClient, HttpStatusCode } from '../protocols/http'
import { LoadWorkLocationList } from '@/javascript/domain/usecases'
import { AccessDeniedError, UnexpectedError } from '@/javascript/domain/errors'

export class RemoteLoadWorkLocationList implements LoadWorkLocationList {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<RemoteLoadWorkLocationList.Response>
  ) {}

  async load(params?: LoadWorkLocationList.Params): Promise<LoadWorkLocationList.Model[]> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
      params: {
        date: params?.date?.toISOString(),
        q: params?.searchText,
        resource_place_ids: params?.resourcePlaces,
        form_ids: params?.forms,
        project_ids: params?.projects,
        provider_ids: params?.providers,
        inspector_ids: params?.inspectors,
        status: params?.status,
        work_finish_option_ids: params?.finishOptions
      }
    })
    const locations = httpResponse.body
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return formatData(locations)
      case HttpStatusCode.noContent: return []
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}

export namespace RemoteLoadWorkLocationList {
  export type Location = {
    work_id: number
    title: string
    status: string
    start_time: string
    latitude: string
    longitude: string
    account_id: number
    resource_place_id: number
    resource_place_name: string
    is_late: boolean
  }
  export type Response = {
    work_locations?: Location[]
  }
}

const formatData = (locations: RemoteLoadWorkLocationList.Response): LoadWorkLocationList.Model[] => {
  return locations?.work_locations?.map(location => ({
    id: location.work_id,
    description: location.title,
    status: location.status as 'not_started' | 'started' | 'finished' | 'reviewed',
    startTime: location.start_time,
    latitude: location.latitude,
    longitude: location.longitude,
    accountId: location.account_id,
    resourcePlaceId: location.resource_place_id,
    resourcePlaceName: location.resource_place_name,
    isLate: location.is_late
  })) || []
}
